import { useAppSelector, useAppDispatch } from '@/hooks/redux-helpers';
import { useDashboardConstants } from '@/hooks/useDashboardConstants';

import { updateFavorites } from '@/features/dashboard-users/store/support-user.actions';

import { TFavorite, TFavoriteItemType } from '@/features/dashboard-users/store/support-user.model';

export function useFavorites() {
  const currentSupportUser = useAppSelector((state) => state.auth.currentSupportUser?.state);
  const favorites = currentSupportUser?.metadata?.favorites || [];
  const dispatch = useAppDispatch();
  const { maxFavorites } = useDashboardConstants();

  const isLoading = currentSupportUser?.metadata?.edit?.isLoading;
  const currentFavoriteId = currentSupportUser?.metadata?.edit?.state?.id;

  const isStarred = (type: TFavoriteItemType, id: number) => {
    return favorites?.some((item) => {
      if (item.type === type) {
        if (item.type === 'wallet') return item.walletId === id;
      }
      return false;
    });
  };

  const handleFavorite = (favorite: TFavorite) => {
    if (currentSupportUser?.id) {
      dispatch(updateFavorites(currentSupportUser.id, favorite));
    }
  };

  const isLimitReached = favorites.length >= maxFavorites;

  return {
    currentSupportUser,
    favorites,
    isStarred,
    handleFavorite,
    isLoading,
    currentFavoriteId,
    isLimitReached,
    maxFavorites,
  };
}
